import { render } from "./LabelTooltip.vue?vue&type=template&id=2b1aced0"
import script from "./LabelTooltip.vue?vue&type=script&lang=js"
export * from "./LabelTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modals/LabelTooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b1aced0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b1aced0', __exports__)) {
    api.reload('2b1aced0', __exports__)
  }
  
  module.hot.accept("./LabelTooltip.vue?vue&type=template&id=2b1aced0", () => {
    api.rerender('2b1aced0', render)
  })

}


export default __exports__